module.exports = __webpack_public_path__ + "img/840.f74e4673.svg";